<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>拼团管理</Breadcrumb-item>
        <Breadcrumb-item>拼团记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="手机号">
                <Input placeholder="不支持模糊搜索" name="userMobile"
                  v-model="queryParam.mobile"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="状态">
              <Select v-model.number="queryParam.status" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in $constant.groupStatus"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="16" :md="8">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/spellgroup/list"
      :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>

</template>
<script>
  export default {
    components: {},
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        passLoading: false,
        reload: 0,
        uid: null,
        queryParam: {
          status: null,
          mobile: '',
        },
        title: [
          {
            title: '拼团ID',
            // width: 80,
            align: 'center',
            key: 'id'
          },
          {
            title: '团长ID',
            // width: 100,
            align: 'center',
            key: 'uid'
          },
          {
            title: '团长手机号',
            align: 'center',
            // width: 150,
            key: 'mobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '团长课程顾问',
            align: 'center',
            // width: 150,
            key: 'adviser'
          },
          {
            title: '团员ID',
            align: 'center',
            // width: 150,
            key: 'memberIds'
          },
          {
            title: '团员手机号',
            align: 'center',
            // width: 250,
            key: 'memberMobiles'
          },
          {
            title: '团员课程顾问',
            align: 'center',
            // width: 300,
            key: 'memberAdviser'
          },
          {
            title: '状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.groupStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
      viewPic (row) {
        this.showImgList = row.urls
        this.showImgModal = true
      },
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookCourseChangeList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      exportData (type) {
        this.exportLoading = true
        this.$http.get('/bookCourseChange/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '补课时记录.csv'
          link.click()
          this.exportLoading = false
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// SpellGroupList.vue?241f616d